import { Injectable } from "@angular/core"
import { APP_INJECTOR } from "app.module"
import { AppHttp } from "core/http"

@Injectable()
export class WebviewLogService {

  protected _appHttp: AppHttp

  constructor() {
    this._appHttp = APP_INJECTOR.get(AppHttp)
  }

  public static driverEvent(event, data: object = null) {
    let wls = new WebviewLogService()
    wls.driverEvent(event)
  }

  public static errorEvent(event) {
    let wls = new WebviewLogService()
    wls.errorEvent(event)
  }

  public driverEvent(event: string, data = null) {
    const time = new Date().toISOString()
    this.remoteSend('driver_event', { event, data, time })
  }

  public errorEvent(error: string) {
    this.remoteSend('error_event', { event: error })
  }

  protected remoteSend(target: string, params: object) {
    let url = `/logs/${target}s`
    let body = JSON.stringify(params)
    return this._appHttp.post(url, body).subscribe(
      resp => console.log(resp), 
      err => console.warn(err)
    )
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/pages/webview/webview-log.service.ts